import React, { FC } from "react";
import cn from "classnames";
import TeamPhoto from "src/assets/images/team.jpeg";
import DealPhoto from "src/assets/images/deal.webp";
import { FolderWrapper } from "../FolderWrapper";
import { AdvantageCard } from "./AdvantageCard";
import {
  EXPERIENCE_AND_APPROACH_CARDS,
  INNOVATION_AND_PRICE_CARDS,
} from "./constanst";
import { SECTION_IDS } from "../constants";

const DEFAULT_IMAGE_CLASSNAME =
  "hidden absolute w-[35.5%] h-[calc(50%-6px)] rounded-xl object-cover object-center xl:flex 4xl:w-[34.5%] 4xl:h-[calc(50%-10px)]";

export const AdvantagesSection: FC = () => (
  <FolderWrapper
    title="Переваги"
    className="grid gap-3 bg-white-base text-green-base px-5 py-8.25 sm:grid-cols-2 md:px-30.75 md:py-16.75 xl:grid-cols-3 xl:grid-rows-2 4xl:gap-5"
    id={SECTION_IDS.ADVANTAGES}
  >
    <img
      src={TeamPhoto}
      className={cn(DEFAULT_IMAGE_CLASSNAME, "top-0 right-0")}
      alt="team"
    />

    {EXPERIENCE_AND_APPROACH_CARDS.map((card) => (
      <AdvantageCard key={card.id} {...card} />
    ))}

    <GridPlaceholder />
    <GridPlaceholder />

    {INNOVATION_AND_PRICE_CARDS.map((card) => (
      <AdvantageCard key={card.id} {...card} />
    ))}

    <img
      className={cn(DEFAULT_IMAGE_CLASSNAME, "bottom-0 left-0")}
      src={DealPhoto}
      alt="deal"
    />
  </FolderWrapper>
);

const GridPlaceholder = () => (
  <div className="hidden w-full h-full xl:inline-block" />
);
